export const sortDirection = {
    ASC: 'asc',
    DESC: 'desc'
};
export const labelPosition = {
    START: 'start',
    END: 'end'
};
export default {
    sortDirection,
    labelPosition
};
